import styled from "@emotion/styled";
import type { TableToolbarProps } from "./DataTable.types";

/* Exact compiled output of the pre-migration Tailwind utilities. */

const TableToolbarRoot = styled("div", {
  label: "AgenticTableToolbar-root"
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: ".75rem",
  borderBottomWidth: "1px",
  "--tw-border-opacity": "1",
  borderColor: "hsl(var(--bfrs-color-border) / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  backgroundColor: "hsl(var(--bfrs-color-surface-card) / var(--tw-bg-opacity, 1))",
  paddingLeft: "1.25rem",
  paddingRight: "1.25rem",
  paddingTop: ".5rem",
  paddingBottom: ".5rem"
});

const TableToolbarText = styled("div", {
  label: "AgenticTableToolbar-text"
})({
  minWidth: "0px"
});

const TableToolbarTitle = styled("div", {
  label: "AgenticTableToolbar-title"
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: ".875rem",
  lineHeight: "1.25rem",
  fontWeight: 700,
  "--tw-text-opacity": "1",
  color: "hsl(var(--bfrs-color-text-primary) / var(--tw-text-opacity, 1))"
});

const TableToolbarDescription = styled("div", {
  label: "AgenticTableToolbar-description"
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: ".75rem",
  lineHeight: "1rem",
  "--tw-text-opacity": "1",
  color: "hsl(var(--bfrs-color-text-muted) / var(--tw-text-opacity, 1))"
});

const TableToolbarTotal = styled("div", {
  label: "AgenticTableToolbar-total"
})({
  fontSize: ".75rem",
  lineHeight: "1rem",
  "--tw-text-opacity": "1",
  color: "hsl(var(--bfrs-color-text-muted) / var(--tw-text-opacity, 1))"
});

const TableToolbarSpacer = styled("div", {
  label: "AgenticTableToolbar-spacer"
})({
  minWidth: ".5rem",
  flex: "1 1 0%"
});

const TableToolbarLoading = styled("span", {
  label: "AgenticTableToolbar-loading"
})({
  fontSize: ".75rem",
  lineHeight: "1rem",
  "--tw-text-opacity": "1",
  color: "hsl(var(--bfrs-color-text-muted) / var(--tw-text-opacity, 1))"
});

export function TableToolbar({ title, description, totalLabel, loadingLabel, search, actions, columnVisibility, className }: TableToolbarProps) {
  return (
    <TableToolbarRoot className={className}>
      {(title || description || totalLabel) && (
        <TableToolbarText>
          {title && <TableToolbarTitle>{title}</TableToolbarTitle>}
          {description && <TableToolbarDescription>{description}</TableToolbarDescription>}
          {totalLabel && <TableToolbarTotal>{totalLabel}</TableToolbarTotal>}
        </TableToolbarText>
      )}
      {search}
      <TableToolbarSpacer />
      {loadingLabel && <TableToolbarLoading>{loadingLabel}</TableToolbarLoading>}
      {columnVisibility}
      {actions}
    </TableToolbarRoot>
  );
}
